// extracted by mini-css-extract-plugin
module.exports = {"container":"mapRecentContainer_container__1dw4u","itemContainer":"mapRecentContainer_itemContainer__1A9sD","itemInfo":"mapRecentContainer_itemInfo__R_TCx"};